import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-demo-symbol',
  templateUrl: './demo-symbol.component.html',
  styleUrls: ['./demo-symbol.component.css']
})
export class DemoSymbolComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-symbol/demo-symbol.component.ts